

import { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { auth } from "helper/Utility";
import { scheduleAutoLogout, clearAutoLogout } from "helper/tokenExpiry";

const ProtectedAdminRoute = ({ children }) => {
  const navigate = useNavigate();
  const authData = auth("admin");

  // No token → go to login
  if (!authData?.token) {
    return <Navigate to="/admin/login" replace />;
  }

  // Wrong role → go to login
  if (authData?.role !== "admin") {
    return <Navigate to="/admin/login" replace />;
  }

  // 2FA not verified → back to login
  if (!authData?.is2FAVerified) {
    return <Navigate to="/admin/login" replace />;
  }

  // Check if token is already expired (handles page refresh after expiry)
  try {
    const payload = JSON.parse(atob(authData.token.split('.')[1]));
    if (payload.exp * 1000 < Date.now()) {
      sessionStorage.clear();
      return <Navigate to="/admin/login" replace />;
    }
  } catch (e) {
    sessionStorage.clear();
    return <Navigate to="/admin/login" replace />;
  }

  return (
    <TokenExpiryWatcher navigate={navigate}>
      {children}
    </TokenExpiryWatcher>
  );
};

// Separate component so useEffect runs only after all guard checks pass
const TokenExpiryWatcher = ({ children, navigate }) => {
  useEffect(() => {
    // Auto-logout when token expires (2h) — works even if user stays on page
    scheduleAutoLogout(() => {
      sessionStorage.clear();
      navigate('/admin/login', { replace: true });
    });

    return () => clearAutoLogout(); // cleanup on unmount
  }, [navigate]);

  return children;
};

export default ProtectedAdminRoute;
